<template>
	<div class="">
    <van-list
			v-model="loading"
			:finished="finished"
			:finished-text="finishedtext"
			:immediate-check="false"
			@load="initData"
		>
			<div class="list_every pd-16-18 box-s mb-16" :class="{ 'preevery': index == list.length - 1 }" v-for="(item, index) in list" :key="index">
        <div class="flexs flex-jus">
          <div class="flexs">
            <img class="wh_46 b-radius-50 mr-10" src="../../assets/img/icon/imitate_icon.png" alt="">

            <div class="fw-500 fz-16 c1 w157 text-hide">{{item.name}}</div>
          </div>
          <div class="flexs  whl-74-24 flex-center fw-500 fz-12 b-radius-12 bg_ec c0"  @click="getStart(item)"> 
            答题报告
            <img  class="wh_4_6 ml-5" src="../../assets/img/icon/blue_right_arrow.png" alt="">
          </div>
        </div>

        <div class="flexs fw-500 fz-14 c1 pd-16 box-s bg_f9 b-radius-6 mtb-16">
          <div class="flex1">题目数量： {{item.numbers}}题</div>
          <div class="flex1">总分： {{item.score}}分</div>
        </div>

        <div class="flexs fw-400">
          <div class="flex1 pl-14 box-s">
            <div class="mb-14 fz-12 c1">练习时间</div>
            <div class="fz-14 c3 l-h-14">{{item.finish_time}}</div>
          </div>
          <!-- <div class="flex1 pl-14 box-s">
            <div class="mb-14 fz-12 c1">考试时限</div>
            <div class="fz-14 c3 l-h-14">{{item.minute}}分钟</div>
          </div> -->
        </div>

        <!-- <div class="c0 flexs flex-end pt-14 bt_e9 mt-18" v-if="item.tp_m == 2">
          <div class="mr-10 fz-12">查看本科排行</div>
          <img class="wh_8_10" src="../../assets/img/icon/blue_k_arrow.png" alt="">
        </div> -->
    </div>
		</van-list>
   

		<loading :loadFlag="loadFlag"></loading>
		<noData v-if="show"></noData>
	</div>
</template>
<script>
	import noData from "@/components/noData"
	import loading from "@/components/loading"
	import { matchExamLog } from '@/api/api'
  import { getList } from '@/utils/common'
	export default {
		components: {
			loading,
			noData
		},
		data() {
			return {
			  list: [],
				loadFlag: false,
        show: false,
				loading:false,
				finishedtext: '',
				finished: false,
				page: 1,
			};
		},
		created() {
			if(this.$route.query.flag){
        document.title = '我的模拟大赛'
			} else{
				document.title = '我的练习'
			}
      this.initData()
		},
		mounted(){
			
		},
		methods: {
			async initData(){
        getList(this, matchExamLog,  { page: this.page, subject_id: 0 }, '', 2)
			},
      		// 开始考试
			getStart( data ){
				this.$router.push({ path: '/midereport', query: { answer_id: data.answer_id } })
			},
      
		}
	};
</script>
<style lang="less" scoped>
.preevery {
	margin-bottom: 0;
}
</style>
